import { addMinutes, format } from "date-fns";
import { arSA, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

import { formatImgUrl } from "../utils/cardFormating";
import { GoEvent } from "../types";

export const useEventDataFormatter = (event?: GoEvent) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const selectedLocale = currentLang === "ar" ? arSA : enUS;

  const {
    id = "",
    name = "Unknown",
    noAcceptedPlayers: acceptedPlayersNum = 0,
    noPlayers: totalPlayersInvitedNum = 0,
    privacy,
    type,
    status,
    location = {
      locationTitle: "",
      locationSubTitle: "",
      lat: null,
      lon: null,
    },
    createdAt = new Date().toISOString(),
    duration,
    players = [],
    author = { firstName: "Unknown", lastName: "Author", id: "", media: null, entity: null },
    description = "",
    startDate,
  } = event || {};
  const createdAtDate = createdAt ? new Date(createdAt) : new Date();
  const startDateValue = startDate ? new Date(startDate) : createdAtDate;

  const startingDay = format(startDateValue, "d", { locale: selectedLocale });
  const startingMonth = format(startDateValue, "MMM", {
    locale: selectedLocale,
  });
  const startingHour = format(startDateValue, "h:mm a", {
    locale: selectedLocale,
  });

  let endDate;
  let endHour;
  if (duration && !isNaN(duration)) {
    endDate = addMinutes(startDateValue, duration);
    endHour = format(endDate, "h:mm a", { locale: selectedLocale });
  } else {
    endHour = "Invalid Duration";
  }

  const eventPrivacy = privacy ? t(`pages.events.eventList.${privacy}`) : "Unknown";
  const eventType = type ? t(`pages.events.eventList.${type}`) : "Unknown";
  const eventStatus = status ? t(`pages.events.eventList.${status}`) : "Unknown";

  const eventLocation = location.locationTitle || location.locationSubTitle || "Unknown",
    eventLat = location?.lat ?? null,
    eventLon = location?.lon ?? null;

  const invitedPlayersAvatars =
    players.map((player: any) => ({
      name: `${player.firstName || "N/A"} ${player.lastName || ""}`.trim(),
      media: formatImgUrl(player.media),
      firstTwoChr: `${(player.firstName?.slice(0, 1) || "").toUpperCase()}${(
        player.lastName?.slice(0, 1) || ""
      ).toUpperCase()}`,
    })) || [];

  const authorName = `${author.firstName} ${author.lastName}`.trim();
  const authorMedia = formatImgUrl(author?.media || author?.entity?.mediaUrl);
  const authorFirstTwoChr = `${author.firstName.slice(0, 1).toUpperCase()}${author.lastName.slice(0, 1).toUpperCase()}`;
  const authorId = author.id;

  return {
    id,
    name,
    description,
    totalPlayersInvitedNum,
    acceptedPlayersNum,
    startingDay,
    startingMonth,
    startingHour,
    endHour,
    privacy,
    eventPrivacy,
    type,
    eventType,
    status,
    eventStatus,
    eventLocation,
    eventLat,
    eventLon,
    invitedPlayersAvatars,
    authorId,
    authorName,
    authorMedia,
    authorFirstTwoChr,
  };
};
